import http from './http'
import { handleHttpError } from './httpHelpers'

export function getRegionsService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniRegioni",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/regione/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getShippingOptionsService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniOpzioniSpedizione",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/regione/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function addShippingService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_aggiungiSpedizione",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getPaymentMethodsService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniMetodiPagamento",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function addPaymentMethodService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_aggiungiMetodoPagamento",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getAddressesService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniIndirizzi",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/regione/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function addAddressService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_aggiungiIndirizzo",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

